<template>
  <div ref="chatQuestions" class="chat-multi" v-if="multiMessages && !isDisabled">
    <button v-for="(multi, index) in multiMessages" :key="index" :class="[
    'chat-multi-item',
    selectedButtons.some(button => button.value === multi.value) ? 'active' : ''
  ]" @click="
    buttonClick({
      text: $t(multi.name),
      value: multi.value,
      text_without_t: multi.name,
      action: multi.action,
    })
    " :disabled="disabled">
      {{ $t(multi.name) }}
    </button>
    <button class="surprise-me" @click="
    surpriseGiftClick()
    " :disabled="disabled" v-if="surpriseGiftButton">
      {{ $t(surpriseGiftButton.name) }}
      <i class="material-icons ">auto_awesome</i>
    </button>
    <button 
    v-show="shouldDisplayNextStep"
    class="chat-buttons submit-multi" @click="
    submitClick(selectedButtons)
    " :disabled="disabled">
      {{ $t('text.submit') }}
    </button>
  </div>
</template>

<script>
import utils from "../utils";
import { customLogger } from "../utils";
export default {
  name: "Multi",
  components: {
  },
  data: () => {
    return {
      selectedButtons: [],
      shouldDisplayNextStep: false,
      isDisabled: false,
    };
  },
  props: {
    multi: {
      type: Array,
      required: true,
      default: () => [],
    },

  },
  mounted() {
    this.scrollToBottom();
    if (this.selectedButtons.length > 0) {
      this.shouldDisplayNextStep = true;
      this.scrollToBottom();
    }

  },
  watch: {
    userMessages() {
      return this.$store.state.user.messages;
    },
    selectedButtons: function (val) {
      if(this.isDisabled) return;
      if (val.length > 0) {
        this.shouldDisplayNextStep = true;

      } else {
        this.shouldDisplayNextStep = false;
      }
      this.scrollToBottom();
    },
  },
  computed: {

    multiMessages() {

      let multi = this.getMultiFromMessages();
      return Object.values(multi).filter((item) => item.value !== 'surprise_gift');
    },
    surpriseGiftButton() {
      let multi = this.getMultiFromMessages();
      const button = Object.values(multi).find((item) => item.value === 'surprise_gift');
      customLogger("surpriseGiftButton", button);
      return button
    },

  },
  methods: {
    scrollToBottom() {
      this.$nextTick(() => {
        utils.scrollDown();
      });
    },
    buttonClick(button) {
      const index = this.selectedButtons.findIndex(selectedButton => selectedButton.value === button.value);
      if (index !== -1) {
        this.selectedButtons.splice(index, 1);
      } else {
        this.selectedButtons.push(button);
      }
    },

    surpriseGiftClick() {
      this.isDisabled = true;
      const selectedButtons = [];
      const availableMessages = this.multiMessages;
      const totalMessages = availableMessages.length;

      const tryAddUniqueButton = (message) => {
        const isAlreadySelected = selectedButtons.some(button => button.value === message.value);
        if (!isAlreadySelected) {
          selectedButtons.push({
            text: this.$t(message.name),
            text_without_t: message.name,
            value: message.value,
            action: message.action,
          });
        }
      };

      tryAddUniqueButton(availableMessages[Math.floor(Math.random() * totalMessages)]);

      let additionalSelectionsCount = Math.floor(Math.random() * (totalMessages - 1)) + 1;
      for (let i = 0; i < additionalSelectionsCount; i++) {
        tryAddUniqueButton(availableMessages[Math.floor(Math.random() * totalMessages)]);
      }
      this.shouldDisplayNextStep = false;
      this.selectedButtons = selectedButtons;
      this.submitClick()
    },

    getMultiFromMessages() {
      const length = this.$store.state.user.messages.length;
      const messages = this.$store.state.user.messages;
      if (messages[length - 1] && messages[length - 1]?.content?.multi) {
        return messages[length - 1].content.multi;
      }
      return [];
    },
    submitClick() {
      this.isDisabled = true;
      const text = this.selectedButtons.map(button => this.$t(button.text_without_t)).join(", ");

      const button = {
        text: text,
        text_without_t: this.selectedButtons.map(button => button.text_without_t).join(", "),
        selected_values: [...this.selectedButtons.map(button => button.value)],
        value: "next_step",
        action: {
          type: "multiSubmit",
        }
      }
      this.shouldDisplayNextStep = false;
      this.$eb.emit(
        "StyleButtonClick",
        button,
        this.$store.state.user.data.tmp_content
      );
    },

  },
};
</script>